import { render, staticRenderFns } from "./LbaObjectSetPermissions.vue?vue&type=template&id=383a586c"
import script from "./LbaObjectSetPermissions.vue?vue&type=script&lang=js"
export * from "./LbaObjectSetPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports